"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPillOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M3.535 3.535c1.017-1.017 4.243-2.828 7.071 0l9.901 9.9c1.413 1.414 2.497 4.574 0 7.072-2.497 2.497-5.657 1.414-7.071 0l-9.901-9.9c-2.828-2.83-1.017-6.055 0-7.072zm1.414 1.414c-1.489 1.49-.707 3.536 0 4.243l4.243 4.242 4.242-4.242-4.242-4.243c-.707-.707-2.753-1.49-4.243 0zm14.113 14.143c1.49-1.49.707-3.535 0-4.243l-4.242-4.242-4.243 4.242 4.243 4.243c.707.707 2.753 1.49 4.242 0z' }))); };
exports.default = SvgPillOutline;
//# sourceMappingURL=PillOutline.js.map